import {
  setLine1,
  monitorLine,
  setLine3,
  setLineStatisticsConsumption,
  setRateLine,
  setCaseSharingLine,
  setLineSingle,
  setLinePMV
} from "./line";
import {
  monitorBar,
  setBarStatisticsRanking,
  setRateBar,
  setBar,
  setBorderRadiusBar,
  setBarPowerSave,
  setBarBackip,
  setBarAuditOverview,
  setBarCost,
  setBarInterspaceUsage
} from "./bar";
import { setGaugeRadius, setGaugePowerRate, setGaugeWarning } from "./gauge";
import { setPieTotal, setPieCost } from "./pie";

export default {
  setLine1,
  setLine3,
  setRateLine,
  setCaseSharingLine,
  monitorBar,
  monitorLine,
  setLineStatisticsConsumption,
  setLinePMV,
  setBarStatisticsRanking,
  setRateBar,
  setBar,
  setBorderRadiusBar,
  setGaugeRadius,
  setPieTotal,
  setPieCost,
  setLineSingle,
  setGaugePowerRate,
  setBarPowerSave,
  setBarBackip,
  setBarAuditOverview,
  setGaugeWarning,
  setBarCost,
  setBarInterspaceUsage
};
